import type { PageWithLayout, PageProps } from "@types";
import type { Meta } from "@layouts/page";
import type { GetServerSideProps } from "next";

import Page from "@layouts/page";
import { useTranslations } from "use-intl";
import { setContext } from "@utils/Cookies";
import { getLayout as getDefaultLayout } from "@layouts/default-layout";
import CartContainer from "@templates/cartContainer";

interface Props extends PageProps {}

const CartPage: PageWithLayout<Props> = ({ appFallback }) => {
  const t = useTranslations("");

  const meta: Meta = {
    title: t("client_cart_cart"),
    description: appFallback?.website.description || "Dabdoob",
    keywords: appFallback?.website.keywords,
  };

  return (
    <Page meta={meta}>
      <CartContainer />
    </Page>
  );
};

CartPage.translationFile = "translation";
CartPage.getLayout = (page, props) => getDefaultLayout(page, { ...props }, {});

export const getServerSideProps: GetServerSideProps<Props> = async (ctx) => {
  //Hussein: Very important to set the context here to transfer auth token and locale info from client browser cookies to server
  setContext(ctx);

  return {
    props: {},
  };
};

export default CartPage;
